import { render } from "./dashboard_admin_report.vue?vue&type=template&id=0f24845b"
import script from "./dashboard_admin_report.vue?vue&type=script&lang=js"
export * from "./dashboard_admin_report.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__